// extracted by mini-css-extract-plugin
export default {"labeldiv":"CheckBox_labeldiv__V5-sY","checkbox_wrapper":"CheckBox_checkbox_wrapper__KsFR0"};